<div [formGroup]="formGroup">
  <sc-sub-title><sc-dictionary-label
  dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.supplementary-equipment-title"></sc-dictionary-label></sc-sub-title>
  <sc-content-spacer vertical></sc-content-spacer>

  @if (direction === 'entrance') {
    @if (equipments == null || equipments.length == 0) {
      <sc-no-data></sc-no-data>
    }
    @if (yardPropertiesService.isShowNoHandoutEnabled()) {
      <sc-checkbox-field formControlName="noHandout"
      labelDictionaryKey="tmc.transport.register-entrance-combined.label.nosupplementaryequipmenthandout"></sc-checkbox-field>
    }
    @for (equipment of equipments; track equipment) {
      <sc-content-spacer vertical></sc-content-spacer>
      <app-supplementary-equipment-item [supplementaryEquipment]="equipment"
      (changed)="handleSupplementaryEquipmentChange($event)"></app-supplementary-equipment-item>
    }
  }

  @if (direction === 'leave') {
    @for (eq of outhandedEquipments; track eq) {
      <div>
        <sc-content-spacer vertical></sc-content-spacer>
        <app-outhanded-supplementary-equipment-item
        [supplementaryEquipment]="eq" (changed)="handleOuthandedChanged()"></app-outhanded-supplementary-equipment-item>
      </div>
    }
  }

</div>
